<template>
  <v-btn
    v-bind="$attrs"
    class="feature-button px-4"
    :class="breakpointClass"
    :style="`--default-width: ${cssWidth}; width: var(--feature-btn-width); height: var(--feature-btn-height);`"
    :data-width-2="width"
  >
    <span class="text-body-1 text-sm-h6 font-weight-semi-bold"><slot>{{ text }}</slot></span>
  </v-btn>
</template>

<script setup lang="ts">
// Ширина и высота определяются через css variable и inline style чтобы добиться responsive верстки с помощью css, а не js
type Props = {
  text?: string
  width?: string | number
  wrapperClass?: string
  breakpoint?: 'sm' | 'md'
}

const props = defineProps<Props>()

const cssWidth = computed(() => toCssSize(props.width ?? 'auto'))

const breakpointClass = computed(() => `feature-button_${props.breakpoint ?? 'sm'}`)
</script>
